import { IEvent, delayedCall, dispatcher, killDelayedCall, ingenuity } from "@quest/base-core";
import { IWinLineObject, SlotConstants, SlotEventConstants } from "@quest/slot-core";
import {
  AudioControllerBehavior,
  SlotConstantsBehavior,
  SlotEventConstantsBehavior,
  WinPresentationPanel,
} from "@quest/murka-games-behavior-leopard/dist/";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { GameParserModel } from "../Platform/GameParserModel";
import { SoundConstantGame } from "../Constants/SoundConstantGame";
import { gameConstants } from "../Constants/gameConstants";

export class WinPresentationPanelGame extends WinPresentationPanel {
  private stackOffset: number[][][];
  private playCount: number = 0;

  /**
   * to subscribe game specific events
   */
  public subscribeEvents(): void {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.REMOVE_SCATTER_AFTER_LANDING, this.removeScatterFromReel, this);
    dispatcher.on(eventDispatchers.RESET_TOGGLE_SOUND_COUNTER, this.resetPlaySoundCounter, this);
  }
  public unsubscribeEvents(): void {
    super.unsubscribeEvents();
    dispatcher.off(eventDispatchers.REMOVE_SCATTER_AFTER_LANDING, this.removeScatterFromReel, this);
    dispatcher.off(eventDispatchers.RESET_TOGGLE_SOUND_COUNTER, this.resetPlaySoundCounter, this);
  }
  /**
   * Method overrided to stopstack symbol animation
   */
  protected stopAllWinLineSymbol(): void {
    super.stopAllWinLineSymbol();
    this.clearSymReels();
    this.hideSingleStaticStack();
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) {
      dispatcher.fireEvent(eventDispatchers.STOP_STACK_SYM_ANIM_FG);
    } else {
      if (
        (ingenuity.parserModel as GameParserModel).getOnionOffset().length &&
        (ingenuity.parserModel as GameParserModel).getSelectionScreenAvailable()
      ) {
        dispatcher.fireEvent(
          eventDispatchers.ADD_DISABLED_ONION_ON_REEL,
          (ingenuity.parserModel as GameParserModel).getReelGrid()
        );
      }
      dispatcher.fireEvent(eventDispatchers.STOP_STACK_SYM_ANIM);
      dispatcher.fireEvent(eventDispatchers.SUPSPEPND_WILD_DRAGON_WIN);
    }
  }
  /**
   * to hide 1x1 wizard
   */
  private hideSingleStaticStack(): void {
    this.stackOffset = (ingenuity.parserModel as GameParserModel).getCommonOffsetsOfStackAndWin();
    this.stackOffset.forEach((data: any) => {
      data.forEach((element: any) => {
        const offset = this.reelPanel.getSymbolByPos(element[0], element[1]);
        const staticSym = offset.getStatic();
        staticSym.visible = false;
      });
    });
  }
  /**
   * Method overrided to stopstack symbol animation
   */
  protected winCycleCompleted(): void {
    super.winCycleCompleted();
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) {
      dispatcher.fireEvent(eventDispatchers.STOP_STACK_SYM_ANIM_FG);
    } else {
      dispatcher.fireEvent(eventDispatchers.STOP_STACK_SYM_ANIM);
    }
  }

  /**
   * Method showWinLine overided to update functionality
   */
  protected showWinLine(winLineData: any, currentWinLine: any): void {
    super.showWinLine(winLineData, currentWinLine);
    if (
      (ingenuity.parserModel as GameParserModel).getStackSymPresent() &&
      (ingenuity.parserModel as GameParserModel).getCommonOffsetsOfStackAndWin().length > 0 &&
      ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState
    ) {
      dispatcher.fireEvent(eventDispatchers.PLAY_STACK_WIN_ANIMATION_ON_TOGGLE);
    }
  }
  // Method Override to start win line animation
  public startWinLineAnimation(evt?: IEvent) {
    this.reelPanel.showAllSymbols();
    super.startWinLineAnimation(evt);
  }
  /**
   * to play sound while toggle
   */
  protected playLineWinAnimations(numCycles: number) {
    super.playLineWinAnimations(numCycles);
    (ingenuity.soundManager as any).playSound(
      SoundConstantGame.WIN_LINE_SOUND,
      1,
      false,
      gameConstants.SOUND_LIST_PRELOAD
    );
  }

  private resetPlaySoundCounter(): void {
    this.playCount = 0;
  }
  /**
   * To check if overlay symbols need to animate with toggle
   */
  protected animateWinLineSymbol(winLineData: IWinLineObject) {
    const winLineDataLength = this.model.winLineData.length;
    if (this.playCount < winLineDataLength) {
      let soundInstance = (ingenuity.soundManager as AudioControllerBehavior).getSoundInstance(
        SoundConstantGame.WIN_LINE_SOUND,
        SlotConstantsBehavior.SOUND_LIST_PRELOAD
      );
      if (soundInstance) {
        (ingenuity.soundManager as any).stop(SoundConstantGame.WIN_LINE_SOUND, gameConstants.SOUND_LIST_PRELOAD);
      }
      (ingenuity.soundManager as any).playSound(
        SoundConstantGame.WIN_LINE_SOUND,
        1,
        false,
        gameConstants.SOUND_LIST_PRELOAD
      );
      this.playCount++;
    }
    if (!this.model.playLineWinAnim || !winLineData) {
      this.model.playLineWinAnim = false;
      return;
    }
    console.info("%c Line win animations for %d line", "background:AntiqueWhite; color:Aqua", winLineData.id);
    if (!this.isStopSymAnim) {
      if (this.reelPanel.getModel().animOverlaySymOnToggle) {
        dispatcher.fireEvent(SlotEventConstants.CLEAR_ANIM_LAYER);
      }
      for (let i of winLineData.positions) {
        this.playSymbolAnimation(i[0], i[1]);
        if (this.reelPanel.getModel().animOverlaySymOnToggle) {
          dispatcher.fireEvent(SlotEventConstants.ADD_SYMBOL_TO_ANIM_OVERLAY_LAYER, [i[0], i[1]]);
        }
      }
    }
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      const purpleWild: number[] = ingenuity.configData.checkForLastFlower;
      if ((ingenuity.parserModel as GameParserModel).getWildOnReel().length || purpleWild.length > 0) {
        dispatcher.fireEvent(eventDispatchers.HANDLE_WILD_REEL_DURING_TOGGLE, winLineData.positions);
      }
    }
  }
  /**
   * to handle stcatter symbol completion delay
   */
  protected playScatterWinAnimations(evt: IEvent) {
    const scatterWinData = evt.data;
    let i;
    let j;
    let symbolID;
    if (!(ingenuity.parserModel as GameParserModel).getRetriggerFreeSpins()) {
      !ingenuity.currentGame.state.getCurrentState().model.getIsAutoPlayLeft() &&
        dispatcher.fireEvent(
          SlotEventConstantsBehavior.SHOW_SCATTER_WIN_MSSG,
          (ingenuity.parserModel as GameParserModel).getTriggerScatterWinData()
        );
    }
    if (ingenuity.configData.animationStopInScatterwin) {
      this.stopAllWinAnimations();
    }
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) {
      dispatcher.fireEvent(SlotEventConstants.FG_SCATTER_ANIMATION_STARTED, scatterWinData);
    } else {
      dispatcher.fireEvent(SlotEventConstants.SCATTER_ANIMATION_STARTED, scatterWinData);
    }
    for (i = 0; i < scatterWinData.length; i++) {
      for (j = 0; j < scatterWinData[i].positions.length; j++) {
        symbolID = this.model.getReelGridElement(scatterWinData[i].positions[j][0], scatterWinData[i].positions[j][1]);
        this.playSymbolTriggerAnimationByID(
          symbolID,
          scatterWinData[i].positions[j][0],
          scatterWinData[i].positions[j][1],
          "triggering"
        );
      }
    }
    delayedCall(
      SlotConstants.TimerScatterAnimationEnded,
      SlotConstantsBehavior.TIME_SCATTER_ANIMATION_END,
      function () {
        killDelayedCall(SlotConstants.TimerScatterAnimationEnded);
        if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) {
          dispatcher.fireEvent(SlotEventConstants.FG_SCATTER_ANIMATION_ENDED, scatterWinData);
        } else {
          /**
           * delay used if there is a scatter win without line win, for tickup to complete
           */
          if (!(ingenuity.parserModel as GameParserModel).getHasLineWins()) {
            delayedCall(
              "TickUpComplete",
              200,
              () => {
                killDelayedCall("TickUpComplete");
                dispatcher.fireEvent(SlotEventConstants.SCATTER_ANIMATION_ENDED, scatterWinData);
              },
              this
            );
          } else {
            dispatcher.fireEvent(SlotEventConstants.SCATTER_ANIMATION_ENDED, scatterWinData);
          }
        }
        this.reelPanel.showAllSymbols();
        this.clearSymReels();
        if (
          (ingenuity.parserModel as GameParserModel).getOnionOffset().length &&
          (ingenuity.parserModel as GameParserModel).getSelectionScreenAvailable()
        ) {
          dispatcher.fireEvent(
            eventDispatchers.ADD_DISABLED_ONION_ON_REEL,
            (ingenuity.parserModel as GameParserModel).getReelGrid()
          );
        }
      },
      this
    );
  }
  /**
   * to reomve scatter after landing animation
   */
  private removeScatterFromReel(): void {
    this.reelPanel.showAllSymbols();
    this.clearSymReels();
  }
  /**
   * to stop the symbol animation in free game last spin
   */
  protected stopAllWinAnimations(): void {
    super.stopAllWinAnimations();
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) {
      this.reelPanel.showAllSymbols();
      this.clearSymReels();
    }
  }
}
